import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconCrop$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCrop extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'fbff7fff445044bce0b51cce30abe77824182d4c', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '68d28fd9dd466a44ab8996661f6c2e5c213ce2f3', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '493ba132b4b63ded64984a546da1ef618335bce4', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.75 7.25V15c0 .69.56 1.25 1.25 1.25h7.75v2.25h1.5v-2.25h2.25v-1.5H7.25V3.5h-1.5v2.25H3.5v1.5zM16.25 7v6.25h-1.5v-6h-6v-1.5H15c.69 0 1.25.56 1.25 1.25", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-crop", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-crop"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-crop":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCrop$1);
            }
            break;
    } });
}

const CosmosIconCrop = CosmosIconCrop$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCrop, defineCustomElement };
